import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressAutoCompleteComponent } from './address-auto-complete.component';
import { InputTextModule } from 'primeng/primeng';

@NgModule({
    imports: [
        CommonModule,
        InputTextModule,
    ],
    declarations: [AddressAutoCompleteComponent],
    exports: [AddressAutoCompleteComponent]
})
export class AddressModule { }
